<template>
   <div v-if="showPrintModal"
      class="print-modal-wrapper" :style="{height: `${height}px` }" @click="hidePrintModal">
      <div class="print-modal">
         <span class='close-btn' @click="hidePrintModal">&#10060;</span>
         <el-form ref="form">
            <el-form-item label="Enter map title:" size="small">
               <el-input v-model="mapTitle"></el-input>
            </el-form-item>
            <!-- <div class="form-group">
               <label for="map-title">Enter map title:</label>
               <input type="text" v-model="mapTitle" id="map-title" class="form-control form-control-sm" required>
            </div> -->
            <el-form-item label="Output Filename:" size="small">
               <el-input v-model="filename" aria-required="Filename is required"></el-input>
            </el-form-item>
            <!-- <div class="form-group">
               <label for="map-title"></label>
               <input type="text" v-model="filename" id="map-title" class="form-control form-control-sm" required>
            </div> -->
            <div class="print-map-wrapper">
               <small>Adjust the map extent as per your requirements</small>
               <div id="print-map"/>
            </div>
            <el-collapse>
               <el-collapse-item :name="collapseId">
                  <template slot="title">
                     <span class='title'>Choose legends</span>
                     <input type="checkbox" @click="toggleAllLegend">
                  </template>
                  <div id="legend-layers">
                     <div class="legend-container">
                        <layer-checkbox
                           :language-is-english="languageIsEnglish"
                           v-for="legend in legends"
                           :key="legend.id"
                           :layer="legend"
                        />
                     </div>
                  </div>
               </el-collapse-item>
            </el-collapse>
            <el-form-item>
               <el-button type="primary" @click="submit" rounded>Print Map</el-button>
               <el-button rounded>Cancel</el-button>
            </el-form-item>
            <!-- <div class="form-group my-3 d-flex justify-content-end">
               <button type="submit" class="btn btn-success">Print Map</button>
            </div> -->
         </el-form>
      </div>
   </div>
</template>

<script>
import LayerCheckbox from '../SideBar/LayerCheckbox';
import { Form, FormItem, Input, Button,CollapseItem,Collapse  } from 'element-ui';
import { proxifyWMSLayers, deproxifyWMSLayers, getMap } from '../../js/mapHelpers';
import {
   filterPossibleLayersForLegends,
   getLegendInfoItem,
   getPrintLayout,
   addLegendsToContext,
   copyOLMapToContext,
   drawPolygon,
   drawScaleBar
} from '../../js/mapPrinting';
import jsPDF from 'jspdf';
import { bus } from '../../main';

export default {
   props: ["languageIsEnglish"],
   data()
   {
      return {
         showPrintModal: false,
         mapTitle: "Map",
         filename: "map",
         legends: [],
         height: document.body.clientHeight
      }
   },
   components: {
      'el-form': Form,
      'el-form-item': FormItem,
      'el-input': Input,
      'el-button': Button,
      'el-collapse': Collapse,
      'el-collapse-item': CollapseItem,
      'layer-checkbox': LayerCheckbox,
   },
   created() {
      bus.$on('show-print-map-modal', () =>
      {
         this.showPrintModal = true;
         proxifyWMSLayers();
         window.addEventListener('resize', () => this.height=document.body.clientHeight); // ! fix this in a better way later
         window.setTimeout( () => getMap().setTarget("print-map"), 100 );
         const legendLayers = filterPossibleLayersForLegends( getMap() );
         this.legends = legendLayers.map( getLegendInfoItem );
      });
   },
   methods: {
      hidePrintModal(event)
      {
         if (event && event.target !== event.currentTarget) return;
         this.showPrintModal = false;
         deproxifyWMSLayers();
         getMap().setTarget("map");
      },
      toggleAllLegend(event)
      {
         this.legends.forEach(legend => legend.visible=event.target.checked);
      },
      submit(event)
      {
         event.preventDefault();
         const map = getMap();
         const mapSize = map.getSize();
         const mapResolution = map.getView().getResolution();
         const layout = getPrintLayout();
         bus.$emit('show-loading-modal');

         map.once("rendercomplete", async () =>
         {
            // setting up the canvas
            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = layout.mapFrameSizePxl[0];
            tempCanvas.height =  layout.mapFrameSizePxl[1];
            const context = tempCanvas.getContext("2d");
            // sort the legend by height
            const legendInfos = this.legends.filter( legend => legend.visible ).map( legend =>
            {
               return {...legend};
            }).sort((item1, item2) => item1.imgHeight - item2.imgHeight);

            copyOLMapToContext(context);
            legendInfos.length && await addLegendsToContext(context, {
               legendInfos,
               pos: layout.legendBoxPxl.pos,
               columnWidth: layout.legendBoxPxl.columnWidth,
               height: layout.legendBoxPxl.height
            });
            drawPolygon(context, "black", layout.northArrowCoordsPxl)
            drawScaleBar(context, {x: tempCanvas.width, y: tempCanvas.height })
            context.strokeStyle = "black";
            context.strokeRect(0,0,tempCanvas.width,tempCanvas.height) // map frame border

            // createMapPDF(title, filename, canvas, layout);
            const pdf = new jsPDF("landscape", undefined, "a4");
            pdf.setFont("Times").setFontType("bold").setFontSize(15);
            pdf.text(this.mapTitle, parseInt(layout.pageDim[0] / 2), 9, null, null, "center");
            try
            {
               pdf.addImage(tempCanvas.toDataURL("image/png"), "JPEG", layout.margin, layout.topMargin, layout.mapFrameSize[0], layout.mapFrameSize[1]);
               pdf.save(`${this.filename}.pdf`);
            }
            catch (error)
            {
               console.error(error);
            }

            // reset original map size
            map.setSize(mapSize);
            map.getView().setResolution(mapResolution);
            this.hidePrintModal();
            bus.$emit('hide-loading-modal');
         });
         // set map size to print frame size
         const frameSize = layout.mapFrameSizePxl;
         map.setSize(frameSize);
         const scaling = Math.min(frameSize[0] / mapSize[0], frameSize[1] / mapSize[1]);
         map.getView().setResolution(mapResolution / scaling);
      }
   }
}
</script>
   
<style scoped>
.print-modal-wrapper {
   position: absolute;
   display: block;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: rgba(0, 0, 0, 0.384);
   
   display: grid;
   place-items: center;
   z-index: 98;
   overflow: auto;
}

.print-modal {
   position: relative;
   margin-top: 4em;
   margin-bottom: 1em;
   background: white;
   padding: 1em 2em;
   border-radius: 5px;
}
.print-map-wrapper {
   text-align: center;
}

.close-btn {
   position: absolute;
   right: 1em;
   top: 0.8em;
   display: flex;
   align-items: center;
   justify-content: center;
}

.title {
   font-size: 15px;
}

.title + input[type=checkbox] {
   position: absolute;
   right: 1em;
   top: 1em;
}

.close-btn:hover {
   cursor: pointer;
}

#print-map {
   width: 70vw;
   min-width: 300px;
   height: 500px;
   margin: 1em 0;
   border: solid 1px grey;
}

.legend-container {
   display: flex;
   flex-wrap: wrap;
}

.legend-container div {
   flex: 1 1 200px;
   border-radius: 3px;
   box-shadow: 0px 0px 3px rgba(0,0,0,0.4);
   padding: 0.2em 1em;
   margin: 4px;
}

.form-group label {
   font-size: 14px;
   font-weight: 500;
   margin: 0;
}

.form-control-sm {
   padding: 10px 15px;
}

.el-button {
   margin-top: 10px;
}
</style>